// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { EstimateStatus } from '../Enums/EstimateStatus';
import { EstimateTypes } from '../Enums/EstimateTypes';
export class EstimateInfoForOpportunity {
  estimateId: string;
  baseEstimateId: string;
  estimateName: string;
  description: string;
  status: EstimateStatus;
  type: EstimateTypes;
  author: string;
  opportunityId: string;
  customer: string;
  userTypeId: number;
  userType: string;
  modifiedBy: string;
  owner: string;
  gmPercentage: number;
  totalSellPrice: number;
  projectObject: string;
  subCost: number;
  createdDate: Date;
  lastUploadDate: Date;
  modifiedDate: Date;
  startDate: Date;
  endDate: Date;
  sapSubmissionDate: Date;
  businessUnit: string;
  segment: string;
  salesOffice: string;
  subSegment: string;
  zoneID: number;
  areaID: number;
  costCenter: number;
  taxTypeID: number;
  businessUnitID: number;
  salesOfficeID: number;
  segmentID: number;
  subSegmentID: number;
  custSAPNum: string;
  siteID: string;
  isMarkUpSelected: boolean;
  proposalID: string;
  proposalTaskID: string;
  sellPriceProposalTaskID: string;
  lastProposalGenerated: Date | null;
  proposalLink: string;
  customerSalesforceId: string;
  shipToAccountId: string;
  billToAccountId: string;
  endUserAccountId: string;
  restrictedType: string;
  opportunityGuid: string;
  gckCode: string;
  isCUI: boolean;
  isECS: boolean;
}
